export enum ISUPPLIER_FE_BE_MAPPING_FIELD {
    id = 'id',
    userName = 'userName',
    email = 'email',
    firstName = 'firstName',
    lastName = 'lastName',
    purchaseOrder = 'purchaseOrder',
    companyName = 'companyName',
    companyPOs = 'companyPOs',
    companyParent = 'companyParent',
    buyerContact = 'buyerContact',
    role = 'role',

}
export class ISUPPLIER {
    id: number;
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
    purchaseOrder: string;
    companyName: string;
    companyPOs: string;
    companyParent: string;
    buyerContact: string;
    role: string;

    constructor(params: any = {}, parsed: boolean = true) {

        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.userName = params.userName;
            this.email = params.email;
            this.firstName = params.firstName;
            this.lastName = params.lastName;
            this.purchaseOrder = (params.purchaseOrder || '');
            this.companyName = params.companyName;
            this.companyPOs = (params.companyPOs || '');
            this.companyParent = params.companyParent;
            this.buyerContact = params.buyerContact;
            this.role = params.role;
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.id];
        this.userName = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.userName];
        this.email = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.email];
        this.firstName = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.firstName];
        this.lastName = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.lastName];
        this.purchaseOrder = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.purchaseOrder];
        this.companyName = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.companyName];
        this.companyPOs = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.companyPOs];
        this.companyParent = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.companyParent];
        this.buyerContact = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.buyerContact];
        this.role = respObject[ISUPPLIER_FE_BE_MAPPING_FIELD.role];
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.id] = this.id;
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.userName] = this.userName || '';
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.email] = this.email || '';
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.firstName] = this.firstName || '';
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.lastName] = this.lastName || '';
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.purchaseOrder] = this.purchaseOrder || '';
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.companyName] = this.companyName || '';
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.companyPOs] = this.companyPOs || '';
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.companyParent] = this.companyParent || '';
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.buyerContact] = this.buyerContact || '';
        body[ISUPPLIER_FE_BE_MAPPING_FIELD.role] = this.role || '';
        return body;

    }
}
